var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticClass:"responsive-plot"},[(_vm.width)?_c('Plotly',{attrs:{"data":_vm.data,"layout":{ ..._vm.layout, width: _vm.width },"display-mode-bar":false,"displaylogo":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }